import styled from 'styled-components';

/* ----------------------------- StyledHeaderSection ----------------------------- */

export const StyledFooterSection = styled.section(
    ({ theme }) => `
        background: ${theme.sections.footer.background};
        color: ${theme.sections.footer.a};
        padding: 0 1.5rem 2rem 1.5rem;
        margin-top: 3rem;

        @media screen and (min-width: 67.5rem) {
            padding: 0 2rem 4rem 2rem;
        }

        @media screen and (min-width: 85rem) {
            padding: 0 6rem 4rem 6rem;
        }
    `,
);
